import { useTranslations } from 'next-intl';

import Card from '@commons/components/Card';
import DrupalImage from '@commons/components/Image/Drupal';
import TopoPatternImage from '@commons/components/Image/TopoPattern';
import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';
import { useFormattedDate } from '@commons/hooks/useFormattedDate';
import { Link } from '@commons/i18n/navigation';
import { TEASER_DISPLAY_IMAGE_SIZES } from '@commons/pagebuilder/nodes/images';

import type { WhitePaperNodeProps } from '.';

/**
 * WhitePaper node component for the Teaser display type.
 */

const WhitePaperNodeTeaser = (props: WhitePaperNodeProps) => {
  const t = useTranslations('nodes.whitePaper');

  const { image, title, date, alias, format } = props;

  const upperTitle = format ? format.name : t('label');

  const formattedDate = useFormattedDate(date);

  const renderedImage = image ? (
    <DrupalImage {...image} sizes={TEASER_DISPLAY_IMAGE_SIZES} />
  ) : (
    <TopoPatternImage alt={title} sizes={TEASER_DISPLAY_IMAGE_SIZES} />
  );

  return (
    <Link href={alias}>
      <Card gap="xs" justify="space-between" direction={{ xs: 'column', md: 'row' }}>
        <Flex.Item width={{ xs: 12, md: 6 }}>{renderedImage}</Flex.Item>
        <Flex gap="sm" width={{ xs: 12, md: 6 }} justify="space-between" direction="column">
          <Flex.Item>
            <Text as="h6" level="label-md" transform="uppercase" marginBottom="xxs">
              {upperTitle}
            </Text>
            <Card.Title>{title}</Card.Title>
          </Flex.Item>
          <Text level="body-xs" transform="uppercase" marginBottom="none">
            {formattedDate}
          </Text>
        </Flex>
      </Card>
    </Link>
  );
};

export default WhitePaperNodeTeaser;
